// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"BL-z","carouselContainer":"CL-z"};